import { render, staticRenderFns } from "./DesfazerTrocaTitularidade.vue?vue&type=template&id=4d91435b&"
import script from "./DesfazerTrocaTitularidade.vue?vue&type=script&lang=js&"
export * from "./DesfazerTrocaTitularidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports